import Container from "../components/layout/Container";
import AuctionPopupDisplay from "../components/Popup/PopupDisply/AuctionPopupDisplay";

const PopupDisplay = () => {
  return (
    <Container>
      <AuctionPopupDisplay />
    </Container>
  );
};

export default PopupDisplay;
